var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 1V15M1 8H15","stroke":_vm.color,"stroke-width":"2","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }